import { atom } from "jotai";

export const selectedDroneIdAtom = atom<string | null>(null);
